module.exports = {
  lang: {
    banner1: 'One card, connecting global payment scenarios',
    banner2: 'A New Force in Cross  - Border Payments',
    banner3: '——  GEO SWIFT CARD，Reconstructing the Global Payment',
    banner4: 'GEO SWIFT CARD makes cross - border payments as simple as local',
    banner5: 'Please enter your email address',
    banner6: 'One - Click Registration',

    pay1: 'One card connects global payment scenarios',
    pay2: 'Full - scenario  payment coverage',
    pay3: '“No - dead - angle” support for cross - border business',
    pay4: 'From payment of goods to employee reimbursement, all cross - border scenarios are fully covered',
    pay5: 'Full e - commerce chain: Covering the entire process of e-commerce platform marketing and consumption, integrating e-commerce consumption and advertising placement, enabling more efficient fund management.',
    pay6: 'Employee business travel / procurement: Employees are provided with overseas cards for business trips. It automatically records consumption details and links to the enterprise reimbursement system. No need to advance funds or manually paste invoices. Financial reconciliation is “zero burden”.',




    cost1: `Smart Expense Management  <br> —— Ensure Every Penny is Spent “with Justification”`,
    cost2: 'Precise Expense Control + Automatic Reconciliation:',
    cost3: 'The Secret Weapon for Skyrocketing Financial Efficiency',
    cost4: 'Hierarchical Permission Management: Set different payment limits for the Procurement Department, Marketing Department, and subsidiaries. The per - transaction/monthly limits of employee cards can be flexibly adjusted. Automatic warnings will be triggered when limits are exceeded, avoiding payment risks from the source.',

    secure1: 'One card connects global payment scenarios',
    secure2: 'Safety and Compliance  Double Insurance',
    secure3: 'Cross - border payment is “stable”',
    secure4: 'Compliance with central bank regulations + multiple risk contro',
    secure5: 'Licensed operation guarantee: Rely on a formal payment license, strictly follow domestic and foreign financial supervision requirements.',
    secure6: 'Intelligent risk control system: 7×24 - hour transaction monitoring, automatically intercept abnormal regions, abnormal amounts, and abnormal frequencies, accurately identify fraud and money - laundering risks, and safeguard the “lifeline” of funds.',
    secure7: 'Emergency response mechanism: Dedicated customer service + risk expert team, respond to payment abnormalities within 1 hour, and provide solutions within 4 hours, ensuring cross - border business operations without interruption.',

    speed1: 'One card connects global payment scenarios',
    speed2: 'Immediately Start  the “Acceleration” of  Cross - border Paymen',
    speed3: 'Open an account in 3 steps, apply for a GEO SWIFT CARD for free,',
    speed3_1: 'and enjoy a 20% discount on service fees for the first 3 months!',
    speed4: 'Click 【Consult Now】: Exclusive consultant for 1v1 communication, customize payment solutions according to enterprise needs',
    speed5: '(Submit materials for review: Upload business license and legal representative information, account opening can be completed in as fast as 1 business day)',
    speed6: 'Consult Now',

    question1: 'Frequently Asked Questions',
    question2: 'Introduction to the Use of GEO SWIFT CARD',
    question3: '1、Conduct user identity KYC verification. Real - name authentication can be carried out according to your entity type: Mainland enterprises, Hong Kong enterprises, Singapore enterprises, etc. Once the verification is passed, the usage authority can be activated.',
    question4: '2、When opening the card, select the card user and complete the card opening successfully. Before opening the card, please ensure that the balance of the fund account is sufficient.',
    question5: `What is the Card's Local Currency?`,
    question6: `The card's local currency depends on the card - issuing country. If the card - issuing country is the United States, the local currency is the US dollar.`,
    question7: `Can a Frozen Card Be Used?`,
    question8: `After freezing the card, the card cannot be used for normal consumption, but it does not affect refunds.`,
    question9: `If a Card Is Accidentally Cancelled, Can It Be Restored?`,
    question10: 'A cancelled card cannot be restored. Please operate with caution.',

    chooseUs1: 'Choose Us',
    chooseUs2: 'Accelerate Your Global Business',
    chooseUs3: 'Please enter your email address',
    chooseUs4: 'One - Click Registration',
    chooseUs5: 'I agree',
    chooseUs6: '《Privacy Policy》',
    chooseUs7: 'and related terms.',

    footer1: 'Ready to Start?',
    footer2: 'One - Click Registration',
    footer3: 'Customer Suggestions and Cooperation',
    footer4: 'Payment Card Industry',
    footer5: 'Data Security Standard',
    footer6: 'Aliyun Security Support',
    footer7: '沪公网安备31011502403199号',

    contact1: 'Contact Us',
  }






}






